import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService } from 'tms-lib';
import { TmsWebBaseChartService } from '../base';
import { ChartWeeksSalesContracts } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ChartWeeksSalesContractsService extends TmsWebBaseChartService<ChartWeeksSalesContracts> {
  protected httpService: HttpService;

  public refreshDetails = new Subject<void>();

  constructor() {
    super('ChartWeeksSalesContracts');
  }
}
